import { create } from 'zustand'

interface OrgGroup {
  id: string
  name: string
  role: string
}

interface AuthUser {
  id: string
  email: string
  name: string
  role: string
  org_groups?: OrgGroup[]
}

interface AuthState {
  user: AuthUser | null
  isAuthenticated: boolean
  isLoading: boolean
  /** Active organization group context (ING-64) */
  activeGroup: OrgGroup | null
  setUser: (user: AuthUser | null) => void
  setLoading: (loading: boolean) => void
  logout: () => void
  /** Set the active organization group (ING-64) */
  setActiveGroup: (group: OrgGroup | null) => void
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  activeGroup: null,
  setUser: (user) => set({
    user,
    isAuthenticated: user !== null,
    isLoading: false,
    // Auto-select first group if user has groups and no active group
    activeGroup: user?.org_groups?.[0] ?? null,
  }),
  setLoading: (isLoading) => set({ isLoading }),
  logout: () => set({ user: null, isAuthenticated: false, isLoading: false, activeGroup: null }),
  setActiveGroup: (activeGroup) => set({ activeGroup }),
}))
